/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис для создания JWT, находится в DMZ зоне, непосредственно не участвует в сценариях Партнёра
 */

/**
 * Сервис JWT
 */
export class JwtServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод создание nested JWT токена.
   * Создаёт JWT токен с клеймами переданными в PayloadData, подписывает последним выпущенным приватным ключом платформы Ключ.
   * Токен шифруетется (JWE) публичным ключом, переданным в параметре public_key (обычно это публичный ключ партнёра).
   * Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695865.
   * Метод доступен для: service
   */
  PostKmsJwtCreateJwe = (req: PostKmsJwtCreateJweRequestDto, init?: RequestInit): Promise<PostKmsJwtCreateJweResponseDto> => {
    return fm.request<PostKmsJwtCreateJweRequestDto, PostKmsJwtCreateJweResponseDto>(`${this.host}/kms/internal/api/v1/kms/jwt/create/jwe`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос на создание nested JWT токена
 */
export type PostKmsJwtCreateJweRequestDto = {
  /**
   * Claims (данные включаемые в тело токена)
   */
  data: PostKmsJwtCreateJweRequestPayloadDataDto
  /**
   * Публичный ключ для шифрования
   */
  publicKey: string
}
/**
 * Claims (данные включаемые в тело токена)
 */
export type PostKmsJwtCreateJweRequestPayloadDataDto = {
  /**
   * Словарь значений.
   * Ключи и значения являются строками.
   * # Диапазон: 1..128
   */
  values?: {[key:string]:string}
}
/**
 * Ответ на запрос на формирование токена
 */
export type PostKmsJwtCreateJweResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Nested JWT токен
   */
  readonly data: string
  /**
   * Ошибка
   */
  readonly error: PostKmsJwtCreateJweResponseErrorDto
}>
/**
 * Ошибка
 */
export type PostKmsJwtCreateJweResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Отсутствует ключ для подписания
   */
  readonly privateKeyNotFound: PostKmsJwtCreateJweResponseErrorPrivateKeyNotFoundRequestDto
}>
/**
 * Ошибка
 */
export type PostKmsJwtCreateJweResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Отсутствует ключ для подписания
   */
  readonly privateKeyNotFound: PostKmsJwtCreateJweResponseErrorPrivateKeyNotFoundDto
}>
/**
 * Отсутствует ключ для подписания
 */
export type PostKmsJwtCreateJweResponseErrorPrivateKeyNotFoundRequestDto = {
}
/**
 * Отсутствует ключ для подписания
 */
export type PostKmsJwtCreateJweResponseErrorPrivateKeyNotFoundDto = {
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на создание nested JWT токена
   */
  "PostKmsJwtCreateJweRequest": {
    "kind": "class",
    "text": "Запрос на создание nested JWT токена",
    "fields": {
      /**
       * Claims (данные включаемые в тело токена)
       */
      "data": {
        "type": "PostKmsJwtCreateJweRequest.PayloadData",
        "text": "Claims (данные включаемые в тело токена)",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Публичный ключ для шифрования
       */
      "publicKey": {
        "type": "string",
        "text": "Публичный ключ для шифрования",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Claims (данные включаемые в тело токена)
   */
  "PostKmsJwtCreateJweRequest.PayloadData": {
    "kind": "class",
    "text": "Claims (данные включаемые в тело токена)",
    "fields": {
      /**
       * Словарь значений.
       * Ключи и значения являются строками.
       * # Диапазон: 1..128
       */
      "values": {
        "type": "{[key:string]:string}",
        "text": "Словарь значений.\nКлючи и значения являются строками.\n# Диапазон: 1..128",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 128,
            "message": "Значение не входит в допустимый диапазон. Максимум: 128"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос на формирование токена
   */
  "PostKmsJwtCreateJweResponse": {
    "kind": "class",
    "text": "Ответ на запрос на формирование токена",
    "fields": {
      /**
       * Nested JWT токен
       */
      "data": {
        "type": "string",
        "text": "Nested JWT токен",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostKmsJwtCreateJweResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "PostKmsJwtCreateJweResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Отсутствует ключ для подписания
       */
      "privateKeyNotFound": {
        "type": "PostKmsJwtCreateJweResponse.Error.PrivateKeyNotFound",
        "text": "Отсутствует ключ для подписания",
      },
    },
  },
  /**
   * Отсутствует ключ для подписания
   */
  "PostKmsJwtCreateJweResponse.Error.PrivateKeyNotFound": {
    "kind": "class",
    "text": "Отсутствует ключ для подписания",
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}